import axios from 'utils/axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';
import { showSuccessModal } from 'actions';

const loader = (label) => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });
const request = () => ({ type: types.PROGRAM_SETUP_CATEGORIES_REQUEST });

const snackbar = (msg, type = 'general_error') => ({
    type: types.SHOW_SNACKBAR,
    snackbar_notification: msg,
    snackbar_notification_type: type,
});

const handleError = (error, dispatch) => {
    const res = error?.response;
    if (res?.status === 422) {
        dispatch({ type: types.PROGRAM_SETUP_VALIDATION_ERROR, payload: res.data.errors });
    } else {
        dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
    }
};

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action
});

const getHeaders = () => ({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const programSetupRedirectToList = () => ({ type: types.PROGRAM_SETUP_CATEGORIES_REDIRECT });

export const fetchProgramSetups = (data = {}) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.post(`${API_URL}timesheet/program-setup/list`,
        data,
        {  headers: getHeaders() }
    )
    .then(res => {
        dispatch({ type: types.FETCH_PROGRAM_SETUPS, payload: res.data });
        dispatch(hideLoader());
    })
    .catch(err => {
        handleError(err, dispatch);
        dispatch(hideLoader());
    });
};


export const getProgramSetupById = (id, actionType, object_viewed_id) => dispatch => {
  dispatch(loader());
  dispatch(request());

  axios.get(`${API_URL}timesheet/program-setup/${id}`, {
    params: { object_viewed_id },
    headers: getHeaders(),
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(getSuccess(types.PROGRAM_SETUP_GET_SUCCESS)(res.data, actionType));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.PROGRAM_SETUP_VALIDATION_ERROR);
    });
};

export const setupProgramForTracking = (data, onClose) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.put(`${API_URL}timesheet/program-setup/${data.program_id}`, data , { headers: getHeaders() })
        .then(res => {
            dispatch({ type: types.UPDATE_PROGRAM_SETUP_SUCCESS, payload: res.data });
            dispatch(showSuccessModal('Program updated successfully.'));
            dispatch(hideLoader());
            dispatch(programSetupRedirectToList());
            onClose();
        })
        .catch(err => {
            handleError(err, dispatch);
            dispatch(hideLoader());
        });
};


export const detachProgram = (programId, object_viewed_id, filters = {}) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.delete(`${API_URL}timesheet/program-setup/${programId}`, {
        headers: getHeaders(),
        params: { object_viewed_id },
        
    })
    .then(() => {
        dispatch({ type: types.DETACH_PROGRAM_SETUP_SUCCESS, payload: programId });
        dispatch(showSuccessModal('Program detached successfully.'));
        dispatch(hideLoader());
        dispatch(programSetupRedirectToList());
        
    })
    .catch(err => {
        handleError(err, dispatch);
        dispatch(hideLoader());
    });
};

export const fetchBoundTasks = (programSetupId, params = {}) => dispatch => {
    dispatch(loader());
    dispatch(request());
    return axios.get(`${API_URL}timesheet/program-setup/${programSetupId}/tasks`, { params, headers: getHeaders() })
        .then(res => {
            dispatch({ type: types.FETCH_BOUND_TASKS, payload: res.data });
            dispatch(hideLoader());
            return res;
        })
        .catch(err => {
            handleError(err, dispatch);
            dispatch(hideLoader());
            throw err;
        });
};

export const fetchBoundUsers = (programSetupId, params = {}) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.get(`${API_URL}timesheet/program-setup/${programSetupId}/users`, { params, headers: getHeaders() })
        .then(res => {
            dispatch({ type: types.FETCH_BOUND_USERS, payload: res.data });
            dispatch(hideLoader());
        })
        .catch(err => {
            handleError(err, dispatch);
            dispatch(hideLoader());
        });
};

export const bindTasksToProgram = (program_id, data, onModelClose) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.post(`${API_URL}timesheet/program-setup/bind-tasks`, { program_id, ...data }, { headers: getHeaders() })
        .then(() => {
            dispatch(showSuccessModal('Tasks bound successfully.'));
            dispatch(fetchBoundTasks(program_id, {object_viewed_id: data.object_viewed_id})); // Refresh list
            dispatch(hideLoader());
            onModelClose();
        })
        .catch(err => {
            handleError(err, dispatch);
            dispatch(hideLoader());
        });
};

export const unbindTasksFromProgram = (program_id, task_ids, object_viewed_id) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.post(`${API_URL}timesheet/program-setup/unbind-tasks`, { program_id, task_ids, object_viewed_id }, { headers: getHeaders() })
        .then(() => {
            dispatch(showSuccessModal('Tasks unbound successfully.'));
            task_ids.forEach(task_id => {
                dispatch({ type: types.UNBIND_TASK, payload: task_id });
            });
            dispatch(hideLoader());
        })
        .catch(err => {
            handleError(err, dispatch);
            dispatch(hideLoader());
        });
};

export const bindUsersToProgram = (program_id, data, onModelClose) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.post(`${API_URL}timesheet/program-setup/bind-users`, { program_id, ...data }, { headers: getHeaders() })
        .then(() => {
            dispatch(showSuccessModal('Users bound successfully.'));
            dispatch(fetchBoundUsers(program_id, {object_viewed_id: data.object_viewed_id})); // Refresh list
            dispatch(hideLoader());
            if (onModelClose) onModelClose();
        })
        .catch(err => {
            handleError(err, dispatch);
            dispatch(hideLoader());
        });
};

export const unbindUsersFromProgram = (data) => dispatch => {
    dispatch(loader());
    dispatch(request());
    axios.post(`${API_URL}timesheet/program-setup/unbind-users`, { ...data }, { headers: getHeaders() })
        .then(() => {
            dispatch(showSuccessModal('Users unbound successfully.'));
            data.user_ids.forEach(user_id => {
                dispatch({ type: types.UNBIND_USER, payload: user_id });
            });
            dispatch(hideLoader());
        })
        .catch(err => {
            handleError(err, dispatch);
            dispatch(hideLoader());
        });
};
